import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { GlobalAlertOptions } from '@models';
import { GlobalAlertService } from '@services';

@Component({
  imports: [NgClass],
  selector: 'monitor-ui-alert',
  styleUrls: ['./alert.component.scss'],
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  isErrorAlertVisible: boolean;
  message: GlobalAlertOptions;

  constructor(private globalAlertService: GlobalAlertService) {
    this.isErrorAlertVisible = false;
    this.globalAlertService.message$.subscribe(message => {
      this.displayAlert(message);
    });
  }

  private displayAlert(message: GlobalAlertOptions): void {
    this.message = message;
    this.isErrorAlertVisible = true;
    setTimeout(() => {
      this.isErrorAlertVisible = false;
    }, this.message.timeout);
  }

  get isError(): boolean {
    return this.message.type === 'error';
  }

  get isSuccess(): boolean {
    return this.message.type === 'success';
  }

  get messageClassName(): {
    'alert-success': boolean;
    'global-message': true;
    alert: true;
    'alert-danger': boolean;
  } {
    return {
      alert: true,
      'alert-danger': this.isError,
      'alert-success': this.isSuccess,
      'global-message': true,
    };
  }

  get iconClassName(): {
    'fa-ban': boolean;
    icon: true;
    fa: true;
    'fa-check-circle': boolean;
  } {
    return {
      fa: true,
      'fa-ban': this.isError,
      'fa-check-circle': this.isSuccess,
      icon: true,
    };
  }
}
